export default "__VITE_ASSET__D9vd7O3N__"